import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { ReportSingleService } from '@services/report-single.service';
import { ColumnVisibilityFilterComponent } from '@shared/grid-filters/column-visibility-filter/column-visibility-filter.component';
import { GroupByRowsFilterComponent } from '@shared/grid-filters/group-by-rows-filter/group-by-rows-filter.component';
import { ReportAdditionalFiltersFormComponent } from '../filters/report-additional-filters-form/report-additional-filters-form.component';
import { ReportMainFiltersFormComponent } from '../filters/report-main-filters-form/report-main-filters-form.component';

@Component({
    selector: 'app-report-single-filters',
    standalone: true,
    imports: [
        ReportAdditionalFiltersFormComponent,
        ReportMainFiltersFormComponent,
        GroupByRowsFilterComponent,
        ColumnVisibilityFilterComponent
    ],
    templateUrl: './report-single-filters.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./report-single-filters.component.scss']
})
export class ReportSingleFiltersComponent {
    private readonly service = inject(ReportSingleService);

    readonly currentTab = computed(() => this.service.currentTab());
    readonly allowGrouping = computed(() => this.service.allowGrouping());
    readonly gridSettings = computed(() => this.service.gridSettings());
    readonly isLoading = computed(() => this.service.isLoading());

    onRun(): void {
        if (this.isLoading()) return;
        this.service.run();
    }
}
